import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Cloudinfrarange() {
  return (
    <section
      className="cloud_infra_range machine_six_process p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>6-Step Machine Learning Development Services Process</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>01</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Discovery & Requirement
                        <br /> Analysis
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      Identify business objectives and data sources. Conduct a
                      detailed requirement analysis to outline project scope,
                      goals, and technical specifications.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>02</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Data Collection &<br /> Preparation
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      As a leading cloud infrastructure company, we help you
                      manage multiple cloud environments through unified
                      management and workload mobility. Our solutions reduce
                      complexity and boost flexibility, facilitating flawless
                      workload migration across various cloud providers.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>03</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Feature Engineering
                        <br /> & Selection
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      Extract and select relevant features from the dataset.
                      Utilize domain knowledge and statistical methods to
                      enhance model accuracy and efficiency.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>04</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Model Selection
                        <br /> & Design
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      Choose appropriate algorithms and design model
                      architecture. Evaluate multiple models to identify the
                      best fit for the specific use case.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>05</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Model Training & <br /> Optimization
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      Train the selected model using advanced techniques.
                      Optimize hyperparameters and employ cross-validation to
                      achieve peak model performance and robustness.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>06</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Pre-Deployment <br /> Model Audit
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      Conduct a comprehensive audit of the trained model.
                      Evaluate performance metrics, bias, and fairness to ensure
                      the model meets business and ethical standards.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cloudinfrarange;
